import { ILayerProps } from '@/version-types';

/** 右键菜单事件 */
export enum ContextMenuEvents {
    /** 右键菜单关闭 */
    close = 'context-menu-close',
    /** 保存到我的空间 */
    saveToMySpace = 'context-menu-save-to-my-space',
    /** 添加图片 */
    addImage = 'context-menu-add-image',
    /** 右键菜单打开 */
    show = 'context-menu-show',
    /** 状态变化 */
    stateChange = 'context-menu-state-change',
}

/** 右键菜单导出 */
export interface IExportContextMenuItem {
    key?: string;
    group: number;
    sort: number;
    render: (args: IRenderContextMenuItemArgs, identity: string) => IMenuItemProps | null;
}

export interface IRenderContextMenuItemArgs {
    /** 激活的父图层 */
    activeLayer: ILayerProps | null;
    /** 选中的子图层 */
    pickLayer: ILayerProps | null;
    /** 是否是图片编辑器 */
    isImageEditor: boolean;
    /** 操作图层类型 */
    operateLayerType: string;
}
/** 右击菜单项 */
export interface IMenuItemProps {
    /** 组 */
    group?: number;
    /** 样式 */
    style?: React.CSSProperties;
    /** 是否禁用 */
    disabled?: boolean;
    /** 是否激活 */
    active?: boolean;
    /** 类型 */
    type: string;
    /** 图标 */
    icon?: string | React.ReactElement | React.ReactNode;
    /** 名称 */
    name: string | React.ReactNode;
    /** 描述 */
    desc?: string;
    /** 子菜单 */
    childMenus?: IMenuItemProps[];
    /** 点击事件 */
    onClick?: (e: React.MouseEvent) => void;
    /** 鼠标进入事件 */
    onMouseEnter?: (e: React.MouseEvent) => void;
    /** 鼠标离开事件 */
    onMouseLeave?: (e: React.MouseEvent) => void;
}
/** 自定义右击菜单, 如果返回为null, 则还是使用默认的菜单 */
export type GetCustomContextMenuFn = (args: {
    /** 相对于画布的坐标 */
    stageX: number;
    /** 相对于画布的坐标 */
    stageY: number;
    /** 相对于页面的坐标 */
    clientX: number;
    /** 相对于页面的坐标 */
    clientY: number;
}) => IMenuItemProps[] | null;
